export const REFERRAL = {
  CONTACT_EMBED: 'Notes,Groups,Addresses,EmailAddresses,PhoneNumbers,Assignment,LeadSources',
  OPPORTUNITIES_EMBED: 'notes,Prequalification,AreasOfInterest,ContactProperty,Offers,OpportunityServiceProviders',
  ACTION: {
    UPDATE_REFERRALS: 'UPDATE_REFERRALS',
    UPDATE_ALL_REFERRALS: 'UPDATE_ALL_REFERRALS',
    INITIALIZE_REFERRAL: 'INITIALIZE_REFERRAL',
    SET_ACTIVE_REFERRAL: 'SET_ACTIVE_REFERRAL',
    SEARCH: 'SEARCH',
    UPDATE_REFERRAL_DETAIL_CARD: 'UPDATE_REFERRAL_DETAIL_CARD',
    RESET_REFERRAL_DETAIL: 'RESET_REFERRAL_DETAIL',
    GET_FILTERED_REFFERAL: 'GET_FILTERED_REFFERAL',
    START_UPDATING_OPPORTUNITY: 'START_UPDATING_OPPORTUNITY',
    UPDATING_OPPORTUNITY: 'UPDATING_OPPORTUNITY',
    END_UPDATING_OPPORTUNITY: 'END_UPDATING_OPPORTUNITY',
    START_UPDATING_OPPORTUNITY_STATUS: 'START_UPDATING_OPPORTUNITY_STATUS',
    UPDATING_OPPORTUNITY_STATUS: 'UPDATING_OPPORTUNITY_STATUS',
    END_UPDATING_OPPORTUNITY_STATUS: 'END_UPDATING_OPPORTUNITY_STATUS',
    FETCH_CONTACT_INFO: 'FETCH_CONTACT_INFO',
    START_FETCH_CONTACT_DATA: 'START_FETCH_CONTACT_DATA',
    END_FETCH_CONTACT_DATA: 'END_FETCH_CONTACT_DATA',
    FETCH_OPPORTUNITY_INFO: 'FETCH_OPPORTUNITY_INFO',
    START_FETCH_OPPORTUNITY_DATA: 'START_FETCH_OPPORTUNITY_DATA',
    END_FETCH_OPPORTUNITY_DATA: 'END_FETCH_OPPORTUNITY_DATA',
    START_OPPORTUNITY_FETCH: 'START_OPPORTUNITY_FETCH',
    SET_OPPORTUNITIES: 'SET_OPPORTUNITIES',
    SET_ACTIVE_OPPORTUNITY: 'SET_ACTIVE_OPPORTUNITY',
    STATUS_UPDATE: 'STATUS_UPDATE',
    END_OPPORTUNITY_FETCH: 'END_OPPORTUNITY_FETCH'
  },
  PENDING_APPOINTMENT_STATUS: 'PENDING_APPOINTMENT_STATUS',
  PENDING_APPOINTMENT_OUTCOME: 'PENDING_APPOINTMENT_OUTCOME',
  CALL_NOW: 'CALL_NOW',
  DEFAULT_CARD: 'DEFAULT_CARD',
  NOTE_DISCLAMIER: ' Your note will be viewable by Xome operations and it\'s affiliates',
  GENERAL: 'General',
  OPPORTUNITY_FETCH_ERROR: 'An error occurred while fetching data',
  UNDER_CONTRACT: 'Under Contract', // renamed as per 247915
  PRE_LIST: 'Pre List'
};

export const FILTER_FIELD = {
  ALL_REFERRAL: 'allReferrals',
  ACTIVE_REFERRAL: 'activeReferralData',
  INACTIVE_REFERRAL: 'inActiveReferral',
  CLOSE_REFERRAL: 'closedReferral'
};
